<!-- <div [class]="print ? 'cover-sheet print-item-break-before' : ''" [style]="print ? 'border: 1px solid lightgray;padding: 1rem' : ''"> -->
<div [class]="print ? 'cover-sheet print-item-break-before' : ''" [style]="{ 'padding-left' : '3rem'}">
  <div class="csh1">{{docConfig.get('packingConditions').label}}</div>
  <div class="csh1" *ngIf="lineItemIdx === undefined">{{compilation.code}} - {{data.getBusinessName(compilation.recipient)}}</div>
  <!-- <div class="csh1" *ngIf="lineItemIdx >= 0">{{compilation.code}}, Pos {{lineItemIdx+1}} - {{data.getBusinessName(compilation.recipient)}}</div> -->
  <div class="csh1" *ngIf="lineItemIdx >= 0">{{compilation.code}} - {{data.getBusinessName(compilation.recipient)}}</div>
  <div style="font-size:1.1rem;white-space:pre-wrap;text-align:center">{{getDeliveryAddress()}}</div>
  <div class="csh2">Dispatch date to final customer: {{vieDispatchDate | date : 'yyyy-MM-dd'}}</div>
  <div class="csh2">
    <span *ngIf="isMixedPallet()" style="padding-right:3em">Mixed Pallet</span>
    <span *ngIf="compilation.customerDocumentNumber">PO: {{compilation.customerDocumentNumber}} Pos: {{tree.getItemOrderPos(this.compilation.lineItems[lineItemIdx])}}</span>
  </div>
  <table class="cover-table">
    <ng-container *ngFor="let item of compilation.lineItems; index as idx">
      <ng-container *ngIf="lineItemIdx === undefined || lineItemIdx === idx">
        <tr>
          <td>{{item.productName}}</td>
          <td *ngIf="item.displayUnit !== 1" style="padding-left: 1em">{{item.displayUnitQuantity}}&nbsp;{{unitData.get(item.displayUnit)?.short}}</td>
          <td style="padding-left: 1em">{{item.quantity}}&nbsp;pc.</td>
        </tr>
        <tr *ngIf="item.attributeRemark || item.attributeCode"><td>{{item.attributeRemark}}; {{item.attributeCode}}</td></tr>
        <tr *ngIf="item.publicRemark"><td>{{item.publicRemark}}</td><td></td><td></td></tr>
        <!-- <tr><td colspan="100">Packing specs: {{getPackingSpecs(item)}}</td></tr> -->
        <!-- <tr><td style="height:0.5rem;"></td></tr> -->
      </ng-container>
    </ng-container>
  </table>

  <!-- <ng-container *ngIf="item.displayUnit !== 1">
    <td style="text-align:right;padding:0 0.5rem 0 2rem;">{{item.displayUnitQuantity}}</td>
    <td>{{unitData.get(item.displayUnit).short}}</td>
  </ng-container> -->

  <br>

  <div class="packing-details">
    <!-- <div style="padding-left: 0.5rem">{{docConfig.get('packingConditions').label}}</div> -->
    <ngx-packing-conditions [compilation]="this.compilation" [print]="true" [coversheet]="true" [lineItemIdx]="lineItemIdx"></ngx-packing-conditions>
  </div>

  <br>

  <!-- <table class="nrk-table"> -->
    <!-- <ng-container *ngFor="let item of compilation.lineItems"> -->
      <!-- <tr *ngIf="data.visibleMap.associatedPfspo && coverSheetSpos.spos.length">
        <td colspan="100" class="related-ocs nrk-smaller-font"> -->
        <!-- <ng-container *ngIf="coverSheetSpos.spos.length">
          <div style="position:relative">
            <div style="padding-left:0.5rem">Associated (PF)SPOs</div>
            <div style="position:absolute;right:1rem;bottom:0"><b style="margin-right:1rem">Σ Assigned Q:</b>{{coverSheetSpos.sumQ}}</div>
          </div>
          <table class="nrk-table"style="width:100%">
            <tr *ngIf="tree.isLoading"><td colspan="100"><ngx-loading-spinner [loading]="tree.isLoading"></ngx-loading-spinner></td></tr>
            <ng-container *ngIf="!tree.isLoading">
              <tr>
                <th>(PF)SPO #</th>
                <th>POS</th>
                <th>Shipment</th>
                <th>Q</th>
                <th>Unit</th>
                <th>Q/pc</th>
                <th>EXW date</th>
                <th>Vie arrival</th>
                <th>(PF)SPO status</th>
                <th>Transport status</th>
                <th>Assigned Q</th>
              </tr>
              <tr *ngFor="let spo of coverSheetSpos.spos">
                <td>{{$any(spo) | documentNumber}}</td>
                <td style="text-align:center">{{spo.pos}}</td>
                <td>{{spo.doc?.directDelivery ? 'direct' : 'indirect'}}</td>
                <td>{{spo.docLineItem?.displayUnitQuantity}}</td>
                <td style="text-align:center">{{unitData.get(spo.docLineItem?.displayUnit)?.short}}</td>
                <td>{{spo.docLineItem?.quantity}}</td>
                <!- - <td>{{spo.doc.readyForPickupDate | date : 'yy-MM-dd'}}</td> - ->
                <td style="text-align:center">{{spo.doc?.exwJapanDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:center">{{spo.doc?.arrivingVieDate | date : 'yy-MM-dd'}}</td>
                <td style="text-align:center">{{spoStatusData.get(spo.doc?.transportRun?.spoStatus)?.name}}</td>
                <td style="text-align:center">{{transportStatusData.get(spo.doc?.transportRun?.transportStatus)?.name}}</td>
                <! -- <td>{{spo.quantity}}</td> - ->
                <td style="text-align:center;width:8rem">{{$any(spo).quantity}}</td>
              </tr>
            </ng-container>
          </table>
        </ng-container> -->
        <!-- </td>
      </tr> -->
    <!-- </ng-container> -->
  <!-- </table> -->
</div>
